const NAMESPACE = 'pipe';
const PIPE_WRITE = 'PIPE_WRITE';
const PIPE_ACQUIRE = 'PIPE_ACQUIRE';

export { NAMESPACE, PIPE_WRITE, PIPE_ACQUIRE };
